module.exports = __webpack_public_path__ + "assets/img/18_1844_big.76cf765b.jpg";